import React from "react";
import "tinymce/tinymce";
import "tinymce/icons/default";
import "tinymce/themes/silver";
import "tinymce/skins/ui/oxide/skin.min.css";
import "tinymce/skins/ui/oxide/content.min.css";
import "tinymce/skins/content/default/content.min.css";
import { Editor } from "@tinymce/tinymce-react";
import "tinymce/plugins/hr";
import "tinymce/plugins/lists";
import "tinymce/plugins/table";
import "tinymce/plugins/advlist";

const TinyEditor = ({ value, setValue, setPlain }) => {
  const handleEditorChange = (content, editor) => {
    setValue(content);
    setPlain(editor.getContent({ format: "text" }));
  };
  return (
    <Editor
      // apiKey="xp3n2pkzdn6ema7qvz740ql1ixjwxlfrk7vzdp11nodc84jz"
      // initialValue={value}
      value={value}
      init={{
        content_style: "body { font-size: 19.5px; }",
        statusbar: false,
        skin: false,
        branding: false,
        auto_focus: value.length > 0 ? false : true,
        resize: false,
        height: "100%",
        menubar: false,
        plugins: ["hr", "lists", "table", "advlist"],
        toolbar:
          "undo redo | formatselect | bold | alignleft | aligncenter | alignright | hr | numlist | bullist | table | forecolor backcolor",
      }}
      onEditorChange={handleEditorChange}
    />
  );
};

export default TinyEditor;
